import { Injectable, signal } from '@angular/core';

/**
 * Lightweight, signal-based toast. Domain effects call `show()` after
 * async work (order placed, sign-in, etc.); the ToastHost renders it.
 */
@Injectable({ providedIn: 'root' })
export class ToastService {
  readonly message = signal<string | null>(null);
  private timer: ReturnType<typeof setTimeout> | null = null;

  show(message: string, ms = 2400): void {
    if (this.timer) clearTimeout(this.timer);
    this.message.set(message);
    this.timer = setTimeout(() => this.message.set(null), ms);
  }

  clear(): void {
    if (this.timer) clearTimeout(this.timer);
    this.message.set(null);
  }
}
